import React, { useState, useEffect } from 'react';
import { frontendDb as db } from '../lib/frontend-db';
import WiesenHeader from './WiesenHeader';
import WiesenFooter from './WiesenFooter';

const WiesenImprint = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    loadWiesenImprint();
  }, []);

  const loadWiesenImprint = async () => {
    try {
      const settings = await db.getSettings();
      if (settings && (settings as any).wiesen_imprint_content) {
        setContent((settings as any).wiesen_imprint_content);
      } else {
        // Default content for Wiesen
        setContent(`Impressum - Liederkranz Wiesen e.V.

Angaben gemäß § 5 TMG:

Liederkranz Wiesen e.V.
Musterstraße 123
63831 Wiesen

Vertreten durch:
1. Vorsitzender: Max Mustermann
2. Vorsitzender: Maria Musterfrau

Kontakt:
Telefon: 06050 / 987654
E-Mail: info@liederkranz-wiesen.de

Registereintrag:
Eintragung im Vereinsregister
Registergericht: Amtsgericht Hanau
Registernummer: VR 12345

Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:
Max Mustermann
Musterstraße 123
63831 Wiesen

Haftungsausschluss:

Haftung für Inhalte
Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.

Haftung für Links
Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.

Urheberrecht
Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.`);
      }
    } catch (error) {
      console.error('Error loading Wiesen imprint:', error);
      setError('Fehler beim Laden des Impressums. Bitte versuchen Sie es später erneut.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen transition-colors duration-300" style={{ backgroundColor: 'var(--bg-primary)' }}>
        <WiesenHeader />
        <main className="container mx-auto px-4 py-16 mt-16">
          <div className="max-w-3xl mx-auto">
            <div className="h-8 rounded w-1/4 mb-4 animate-pulse" style={{ backgroundColor: 'var(--bg-secondary)' }} />
            <div className="space-y-4">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="h-4 rounded animate-pulse" style={{ backgroundColor: 'var(--bg-secondary)' }} />
              ))}
            </div>
          </div>
        </main>
        <WiesenFooter />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen transition-colors duration-300" style={{ backgroundColor: 'var(--bg-primary)' }}>
        <WiesenHeader />
        <main className="container mx-auto px-4 py-16 mt-16">
          <div className="max-w-3xl mx-auto">
            <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-6 text-center">
              <h2 className="text-xl font-semibold text-red-800 mb-2">Fehler</h2>
              <p className="text-red-600 dark:text-red-400">{error}</p>
            </div>
          </div>
        </main>
        <WiesenFooter />
      </div>
    );
  }

  return (
    <div className="min-h-screen transition-colors duration-300" style={{ backgroundColor: 'var(--bg-primary)', '--primary-color': '#2d5a2f' } as React.CSSProperties}>
      <WiesenHeader />
      <main className="container mx-auto px-4 py-16 mt-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold mb-8" style={{ color: '#2d5a2f' }}>Impressum</h1>
          <div className="prose max-w-none">
            {content.split('\n').map((paragraph, index) => (
              <p key={index} className="mb-2 leading-snug min-h-[1.5em]" style={{ color: 'var(--text-primary)' }}>
                {paragraph || '\u00A0'}
              </p>
            ))}
          </div>
        </div>
      </main>
      <WiesenFooter />
    </div>
  );
};

export default WiesenImprint;

